var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-map-page"},[_c('navigator',{attrs:{"headLine":"地图导航"}}),_c('div',{staticClass:"app-other-map-view"},[_c('app-other-map-view',{attrs:{"mapMessage":_vm.mapMessage}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }